export default __webpack_public_path__ + "static/media/LeasePlan-Light.877e8cd5.woff";